import { render } from "./Persoon.vue?vue&type=template&id=eca86dfc"
import script from "./Persoon.vue?vue&type=script&lang=js"
export * from "./Persoon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__